import React, { Component } from "react";
import CardGrid from "./CardGrid";
import SignInSignUp from "./SignInSignUp";
import "../style/EnglishMotets.css";
import SignedIn from "./SignedIn";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// COMPONENTS
import MailchimpSignUp from "./MailchimpSignUp";

export class EnglishMotets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animation: false,
      userSignedUp: null,
      userSignedUpMessage: null
    };
    this.handleUserSignUp = this.handleUserSignUp.bind(this);
  }
  componentDidMount() {
    const userSignedUp = localStorage.getItem("signedUp");
    this.setState(prevState => {
      return {
        animation: !prevState.animation,
        userSignedUp
      };
    });
  }

  handleUserSignUp(message) {
    // This handles user sign ups to mailchimp
    this.setState({
      userSignedUp: true,
      userSignedUpMessage: message
    });
  }

  render() {
    return (
      <div className={this.state.animation ? "animate-in" : ""}>
        {!this.props.authenticated && (
          <div className="welcome-text-container">
            <h1 id="top">Welcome to English Motets</h1>
            <h3>
              If you don't have an account, no worries! Scroll down and start
              browsing our collection
            </h3>
            <p>
              Want to see all the music we have?{" "}
              <Link to="/overview">Click here</Link>
            </p>
          </div>
        )}
        {!this.props.authenticated && <SignInSignUp />}
        {this.props.authenticated && SignedIn()}
        <CardGrid />
        {!this.state.userSignedUp && (
          <MailchimpSignUp handleUserSignUp={this.handleUserSignUp} />
        )}
        {this.state.userSignedUpMessage && (
          <p style={{ textAlign: "center", marginTop: "4rem" }}>
            {this.state.userSignedUpMessage}
          </p>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    authenticated: state.authenticated
  };
};

export default connect(mapStateToProps)(EnglishMotets);



// WEBPACK FOOTER //
// ./src/components/EnglishMotets.js